import styled from 'styled-components/macro';

export const StyledHeroSection = styled.section`
  background-image: url(${props => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: ${({ $fluid }) => ($fluid ? 'auto' : '100%')};
  height: ${({ $fluid }) => ($fluid ? '378px' : '200px')};
  border-radius: ${({ $fluid }) => ($fluid ? '0' : '20px')};
  display: flex;
  align-items: center;
  padding: ${({ $fluid }) => ($fluid ? '20px 20px 20px 125px' : '20px')};
  position: relative;
  /* margin: ${({ $fluid }) => ($fluid ? '0 -15px 30px -125px' : '0 0 30px')}; */
  z-index: 1;

  button {
    position: absolute;
    bottom: 20px;
    right: 20px;
    color: var(--primary-text-color);
    padding: 10px 24px;
    cursor: pointer;
    border-radius: 60px;
    background: #fcfcfd;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    input {
      display: none;
    }

    label {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }
`;
